import request from '@/router/axios'
import env from '@/config/env'

// 获取规则分页
export const evaluateSetting = (params) => {
  return request({
    url: env.ferryUrl + '/evaluation/config',
    method: 'GET',
    params
  })
}
// 获取操作日志
export const operateLog = (params) => {
  return request({
    url: env.ferryUrl + '/bizLog/getBizLogList',
    method: 'GET',
    params
  })
}
// 保存评价配置
export const configSave = (params) => {
  return request({
    url: env.ferryUrl + '/evaluation/config/save',
    method: 'POST',
    data: params
  })
}
// 获取评价分页
export const customEvaluate = (params) => {
  return request({
    url: env.ferryUrl + '/evaluation/page',
    method: 'POST',
    data: params
  })
}
// 获取评价管理的司机信息分页
export const driverOperation = (params) => {
  return request({
    url: env.ferryUrl + '/evaluation/driverOperation',
    method: 'POST',
    data: params
  })
}
